module.exports = __webpack_public_path__ + "img/__icon_MEGA.fc65e5cf.svg";